import { render, staticRenderFns } from "./SendStatus.vue?vue&type=template&id=5e588499&"
import script from "./SendStatus.vue?vue&type=script&lang=js&"
export * from "./SendStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e588499')) {
      api.createRecord('5e588499', component.options)
    } else {
      api.reload('5e588499', component.options)
    }
    module.hot.accept("./SendStatus.vue?vue&type=template&id=5e588499&", function () {
      api.rerender('5e588499', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/SendStatus.vue"
export default component.exports